import { Link } from 'react-router-dom'

export function InventoryDemoNotice({
  showConnectionLink = true,
}: {
  showConnectionLink?: boolean
}) {
  return (
    <aside className="market-demo-banner" aria-label="О демонстрационных данных iiko">
      <strong>Демо iiko · бар с кухней на 50 мест.</strong> 60–80 гостей в обычный день, до 110 в
      субботу. 14 контрольных позиций кухни и бара.
      <details>
        <summary>Как подготовлены данные</summary>
        <p>
          Товары, цены и фасовки взяты из обезличенных прайсов этого демо от 4 ноября 2026 года.
          Остатки рассчитаны по 90 дням продаж порций и регулярным поставкам. Формат заведения,
          продажи и график поставок — условия учебного сценария.
        </p>
        <p>
          Например, 20 порций курицы по 150 г — 3 кг в день; 40 кофе по 18 г — 720 г зерна; 32
          молочных напитка по 160 мл — 5,12 л молока. Для нового пюре накоплено только 5 дней
          истории.
        </p>
        <p>
          Окна расхода и заказ считаются по тем же правилам, что в продукте: медиана падений
          остатков, срок поставки и запас на 3 дня.
        </p>
      </details>
      {showConnectionLink ? (
        <Link className="market-demo-banner__link" to="/demo/iiko">
          Посмотреть подключение, склады и синхронизацию
        </Link>
      ) : null}
    </aside>
  )
}
